// Definizioni di colonna riusabili per le tabelle (DataGrid), complementari ai
// renderer di cella di `table_cells/index.jsx`. Import via barrel `@ui`.

import i18n from 'i18next';

import ServiceModeChip from '../service_mode/ServiceModeChip';

/**
 * Colonna "Modalità di servizio": chip con icona + label localizzata.
 *
 * `hideOnGroupRows` (default true) lascia vuota la cella sulle righe-gruppo
 * (`__kind === 'group'`), che aggregano più ordini e non hanno una modalità
 * propria. `overrides` inoltra qualsiasi prop di colonna MUI (width, flex, ...).
 */
export const serviceModeColumn = ({ hideOnGroupRows = true, ...overrides } = {}) => ({
  field: 'service_mode',
  headerName: i18n.t('service_mode'),
  width: 150,
  renderCell: ({ row }) =>
    hideOnGroupRows && row.__kind === 'group' ? null : <ServiceModeChip order={row} fullCell />,
  ...overrides,
});
